module.exports = __webpack_public_path__ + "assets/redux-framework.aa0a3376.svg";